import Vue from "vue";
import store from './store'
import axios from "axios";
import { getCookie } from './cookie'
import { Message } from 'element-ui'

let url = 'https://ruzhu.hibaodan.com'
const request = axios.create({
  baseURL: process.env.NODE_ENV === 'development' ? 'https://ruzhutest.hibaodan.com' : 'https://ruzhutest.hibaodan.com',
  onUploadProgress: progressEvent => {
    var complete = (progressEvent.loaded / progressEvent.total * 100 | 0);
    store.commit('SET_PROGRESS', complete)
  }
})
request.interceptors.request.use(
  config => {
    config.headers.Authorization = 'Bearer ' + getCookie('token_pc')
    // config.headers.token = 'e15285e3-4f3b-4174-8a35-3b68d395f349'   
    return config
  }
)
request.interceptors.response.use(
  res => {
    if(res.data.code === 200 && res.data.msg && res.data.msg != '请求成功' && res.data.msg != '提交成功' && res.data.msg != '未检测到敏感词') {
      Message.success({message: res.data.msg})
    } else if (res.data.code === -1) {
      Message(res.data.msg)
    }
    if(res.data.code === 200)return res.data
    return Promise.reject(new Error(res.data.msg))
  },
  err => {
    //token 失效
    console.log('err=======', err.response);
    if (err.response && err.response.status === 401) {
      Message.error('请重新登录');
      store.commit('LOG_OUT')
    } else {
      Message({
        message: '网络错误，请重试',
        type: 'error'
      })
    }
    return Promise.reject(err)
  }
)

Vue.prototype.$http = request
Vue.prototype.$url = url